<template>
<div>
  <div class="flex-row flex-nowrap">
    <div class="p-r-8 m-b-xs">
      <el-select clearable v-model="filter.province" filterable placeholder="——省份——" @change="handleChange($event, 'province')">
        <el-option v-for="item in provinces" :key="item.areaCode" :label="item.areaName" :value="item.areaCode">
        </el-option>
      </el-select>
    </div>
    <div class="p-r-8 m-b-xs">
      <el-select clearable v-model="filter.city" filterable  placeholder="——城市——" @change="handleChange($event, 'city')">
        <el-option v-for="item in cities" :key="item.areaCode" :label="item.areaName" :value="item.areaCode">
        </el-option>
      </el-select>
    </div>
    <div class="p-r-8 m-b-xs">
      <el-select clearable v-model="filter.region" filterable  placeholder="——地区——"  @change="handleChange($event, 'region')">
        <el-option v-for="item in regions" :key="item.areaCode" :label="item.areaName" :value="item.areaCode">
        </el-option>
      </el-select>
    </div>
    <div class="flex-row flex-nowrap flex-block justify-content-end m-b-xs">
      <el-button v-if="isShowBtn('add')" class="primary-btn-g m-r-xs" size="small" icon="Plus" name="create" data-toggle="modal" href="#create-form" @click="handleCreate">新增</el-button>
      <el-button v-if="isShowBtn('delete')" class="danger-btn-g m-r-xs" size="small" icon="Delete" name="delete" @click="handleBulkDelete">批量删除</el-button>
    </div>
  </div>
  <!-- <hr /> -->
  <div class="table-responsive no-border">
    <el-table
      v-loading="loading"
      element-loading-spinner="el-icon-loading"
      :data="tableData"
      class="table table-stripped"
      stripe
      :height="height"
      :row-key="updateRowKey"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50" align="center"></el-table-column>
      <el-table-column v-for="(column, index) in tableColumn" :key="index" :prop="column.prop" :render-header="column.renderHeader" :label="column.label" :sortable="column.sortable" :show-overflow-tooltip="true" align="center">
      </el-table-column>
      <el-table-column label="操作" width="180" align="center">
        <template #default="scope">
          <a
              v-if="updatePerm"
              class="btn text-gray btn-xs"
              data-toggle="modal"
              href="#create-form"
              @click="handleEdit(scope.$index, scope.row)"
            >
              <el-tooltip effect="dark" content="编辑" placement="top">
                <span>编辑</span>
              </el-tooltip>
            </a>
            <span class="splitline">|</span>
            <el-popover v-if="deletePerm" placement="top" popper-class="commonTipPop">
              <slot>
                <div style="text-align: left; margin: 0">
                  <span :style="{'color': '@font-color-gray'}">确认删除吗?</span>
                  <br />
                  <br />
                  <el-button class="btn-cancel" size="small" @click="handleClosePopover($event)">取消</el-button>
                  <el-button
                    class="btn-primary"
                    size="small"
                    @click.prevent="handleDelete(scope.$index, scope.row)"
                  >确定</el-button>
                </div>
              </slot>
              <template #reference>
                <a style="padding: 1px 10px" type="text">删除</a>
              </template>
            </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <Pagination class="r-pagination" :pageSize="pageSize" :total="recordTotal" :page="page" @current-change="handlePageChange" />
  </div>
  <Modal :modalTitle="clickModalType" modalId="create-form" @show="modalShow = true" @hide="modalShow = false" @close="modalShow = false" contentId="create-cnt">
    <dictPoliceStationForm :formType="clickModalType" :policeStation="selectPoliceStation" :modalShow="modalShow" @success = "submitSuccess"/>
  </Modal>
  <!--导入Excel模态框-->
  <Modal modalTitle="批量导入" modalId="uploadExcelFile" @show="modalShow=true" @hide='modalShow=false' contentId="upload-cnt">
    <uploadExcelFile :modalShow="modalShow" :downloadUrl='downloadUrl' @submitUpload='handleSubmitUpload' />
  </Modal>
  <!--批量删除-->
  <Modal modalTitle="提示" modalId="delete-modal" class="modal-panel" contentId="delete-cnt">
    <p class="text-notice">
      <i class="el-message-box__status el-icon-warning" style="position:relative;transform:none;padding-right:5px;"></i>
      确定要删除当前选中的<b style='color:red'> {{multipleSelection.length}}</b> 条记录吗?</p>
    <div class="text-center m-t-lg">
      <el-button class="btn-primary font-14 w-80" size="small" @click.prevent="handleSubmitDelete">确定</el-button>
      <el-button class="btn-white font-14 w-80" size="small" data-dismiss="modal">取消</el-button>
    </div>
  </Modal>
</div>
</template>
<script>
import { mapActions } from 'vuex'
import mixin from '@/components/common/tableMixin';
import dictPoliceStationForm from './dictPoliceStationForm'
import uploadExcelFile from './uploadExcelFile'

import dictCommonMixin from './common'

export default {
  name: 'dictPoliceStation',
  mixins: [mixin, dictCommonMixin],
  props: ['height'],
  components: {
    dictPoliceStationForm,
    uploadExcelFile,
  },
  data() {
    const _this = this
    return {
      filter: {
        name: "",
        addr: "",
        policeCode: "",
        areaCode: "",
        province: '',
        city: '',
        region: ''
      },
      pageSize: 20,
      recordTotal: 2,
      clickModalType: '新增',
      page: 1,
      provinces: [],
      cities: [],
      regions: [],
      selectPoliceStation: null,
      loading: false,
      didInvalidate: false,
      modalShow: false,
      maxHeight: null,
      expandColumn: [
        {
          prop: 'xpoint',
          label: '经度'
        },
        {
          prop: 'ypoint',
          label: '纬度'
        },
        {
          prop: 'areaCode',
          label: '地区编码'
        },
        {
          prop: 'comment',
          label: '备注'
        },
      ],
      tableColumn: [
        {
          prop: 'name',
          label: '派出所名称',
          renderHeader: ({column, $index})  => {
            return (
              <el-input onChange={() => _this.submitFilter()}
                        placeholder="请输入派出所名称"
                        v-model={_this.filter.name}
                        nativeOn-keyup={ (event) => { if(event.keyCode === 13) this.submitFilter() } }>
              </el-input>
            )
          }
        },
        {
          prop: 'addr',
          label: '地址',
          renderHeader: ({column, $index})  => {
            return (
              <el-input onChange={() => _this.submitFilter()}
                        placeholder="请输入派出所地址"
                        v-model={_this.filter.addr}
                        nativeOn-keyup={ (event) => { if(event.keyCode === 13) this.submitFilter() } }>
              </el-input>
            )
          }
        },
        {
          prop: 'policeCode',
          label: '派出所编码',
          renderHeader: ({column, $index})  => {
            return (
              <el-input onChange={() => _this.submitFilter()}
                        placeholder="请输入派出所编码"
                        v-model={_this.filter.policeCode}
                        nativeOn-keyup={ (event) => { if(event.keyCode === 13) this.submitFilter() } }>
              </el-input>
            )
          }
        },
        {
          prop: 'phone',
          label: '派出所联系电话'
        },

      ],
      tableData: [],
      toExcel:false,
      downloadUrl: '',
      multipleSelection: [],
    }
  },
  created() {
    let params = {
      areaCode: 0
    }
    let url = 'COMBOBOX.FIND_AREA_LIST_BY_PARENT_CODE'
    this._fetchBasicalData(url, params, 'provinces')
    //获取列表数据
    this.fetchDataIfNeeded({
      params: JSON.stringify({}),
      start: 0,
      size: this.pageSize,
      toExcel:this.toExcel
    })
  },
  mounted(){
    this.maxHeight = $('body').height() - $('.dictMng').offset().top - 165
  },
  watch: {
    'filter.province': function(to) {
      this.filter.city = ''
      this.filter.areaCode = to
      let params = {
        areaCode: to
      }
      let url = 'COMBOBOX.FIND_AREA_LIST_BY_PARENT_CODE'
      this._fetchBasicalData(url, params, 'cities')
    },
    'filter.city': function(to) {
      this.filter.region = ''
      if(to !== ''){
        this.filter.areaCode = to
      }else{
        this.filter.areaCode = this.filter.province;
      }
      let params = {
        areaCode: to
      }
      let url = 'COMBOBOX.FIND_AREA_LIST_BY_PARENT_CODE'
      this._fetchBasicalData(url, params, 'regions')
    },
    'filter.region': function(to) {
      if(to !== ''){
        this.filter.areaCode = to
      }else{
        this.filter.areaCode = this.filter.city;
      }
    }
  },
  methods: {
    ...mapActions([
      'importUpload',
      'alertToggle'
    ]),
    _fetch(params) {
      this._requestData()
      let url = 'DICT.POLICE_STATION_LIST';
      const _this = this
      this.fetchData({
        url,
        method: 'get',
        params
      }).then(res => {
        _this._receiveData()
        if (params.toExcel) {
          this.toExcel = false
          window.location.href = res.data
          return
        }
        _this.recordTotal = res.count
        _this.tableData = _this._getter(res.data) || []
      }).catch(err => {
        _this._receiveData()
        _this.error = err
      })
    },
    _getter(items) {
      return items.map((data, index) => {
        Object.keys(data).forEach(function(key) {
          if (data[key] === null) {
            data[key] = ''
          }
        });
        return data
      })
    },
    _fetchBasicalData(url, params, type) {
      const _this = this
      this.fetchData({url, method: 'get', params}).then(res => {
        this[type] = res.data
      }).catch(err => {
        this.error = err
      })
    },
    _reloadData() {
      let params = {
        params: JSON.stringify(this.filter),
        start: (this.page - 1) * this.pageSize,
        size: this.pageSize,
        toExcel:this.toExcel
      };
      if(this.toExcel && this.multipleSelection.length){
        params.params = JSON.stringify({exportIds:this.multipleSelection.map(item => item.id).join(',')})
      }
      //强制请求数据
      this.refreshData()
      this.fetchDataIfNeeded(params)
    },
    // 分页
    handlePageChange(val, ops) {
      this.page = val;
      this.pageSize = ops;
      this._reloadData();
    },
    handleCreate() {
      this.clickModalType = '新增'
      this.selectPoliceStation = null
    },
    handleEdit(index, row) {
      this.clickModalType = '编辑'
      this.selectPoliceStation = row
    },
    submitSuccess(params) {
      this.filter.province = params.province
      setTimeout(() => {
        this.filter.city = params.city
      }, 100)
      setTimeout(() => {
        this.filter.region = params.region
        this.filter.areaCode = params.region
        this.submitFilter()
      }, 110)
      $('#create-form').modal('hide')
    },
    handleDelete(index, row) {
      let url = 'DICT.POLICE_STATION_DELETE'
      let params = {
        id: row.id
      }
      this.fetchData({
        url,
        method: 'post',
        params,
        timeout:0,
        isLoading:false,
        flag:true
      }).then(res => {
        if(res && res.status==1) {
          this.alertToggle({
            alertType: 'success',
            alertContent: res.msg || '删除成功！'
          })
          this._reloadData()
        }else{
          let tipMsg = (res && res.msg) ? res.msg:'操作失败'
          this.alertToggle({
            alertType: 'danger',
            alertContent: tipMsg
          })
        }
      }).catch(err => {
        this.alertToggle({
          alertType: 'danger',
          alertContent: err
        })
      })
      $('body').trigger('click')
    },
    handleChange(val, ops) {
      this.filter[ops] = val
      //this.filter.areaCode = val;
      switch(ops) {
        case 'province': this.filter.city = ''
          this.filter.region = ''
          this.filter.areaCode = val
          break
        case 'city': this.filter.region = ''
          this.filter.areaCode = val || this.filter.province
          break
        case 'region': this.filter.areaCode = val || this.filter.city
      }
      this.submitFilter();
    },
    handleExportFile(){
      this.toExcel = true
      this._reloadData()
    },
    // 批量导入
    handleImportFile() {
      this.downloadUrl = window.axios.defaults.baseURL + '/commons/combobox/getImportTemplate?fileName=PoliceStation.xls';
      $('#uploadExcelFile').modal('show');
    },
    handleSubmitUpload(val) {
      let url = '/system/general/dictionary/policeStation/importPoliceInfo';
      this.importUpload({ url, params: val }).then(res => {
        this.alertToggle({
          alertType: 'success',
          alertContent: '批量导入成功！'
        })
        this._reloadData()
      }).catch(err => {
        this.alertToggle({
          alertType: 'danger',
          alertContent: err
        })
      })
      $('#uploadExcelFile').modal('hide');
    },
    // 批量删除
    handleBulkDelete() {
      if (this.multipleSelection.length === 0) {
        this.alertToggle({
          alertType: 'danger',
          alertContent: '请选择要删除的数据！',
        })
        return
      }
      //$('#delete-modal').modal('show');
      this.$confirm('确定删除当前选中的（' + this.multipleSelection.length + '条记录）信息吗？', { type: 'warning' })
        .then(() => {
          this.handleSubmitDelete()
        })
        .catch(() => false)
    },
    handleSubmitDelete() {
      let deleteItems = []
      if (this.multipleSelection.length) {
        this.multipleSelection.forEach(item => {
          deleteItems.push(item.id)
        })
      }else{
        this.alertToggle({
          alertType: 'danger',
          alertContent: '请选择相应的记录'
        });
        return
      }
      const url = '/system/dictionary/policeStation/batchDelete';
      const params = {
        params: JSON.stringify({
          id: deleteItems
        })
      }
      this.fetchData({ url, method: 'post', params ,timeout:0,isLoading:false, flag:true}).then((res) => {

        if(res && res.status==1){
          this._reloadData();
          this.alertToggle({
            alertType: 'success',
            alertContent: res.msg || '删除成功！'
          });
        }else{
          let tipMsg = (res && res.msg) ? res.msg:'操作失败'
          this.alertToggle({
            alertType: 'danger',
            alertContent: tipMsg
          })
        }

      }).catch(err => {
        this.error = err
      });
      //$('#delete-modal').modal('hide')
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },

  }
}
</script>
